import { __rest, __assign } from 'tslib';
import React from 'react';
import { Markdown } from './Component.js';
import 'react-markdown';
import 'classnames';
import './use-overrides-70538eaf.js';
import '../../link/esm';
import '../../list/esm';
import '../../typography/esm';
import './remark-plugins/strikethrough.js';
import 'mdast-util-gfm-strikethrough';
import 'micromark-extension-gfm-strikethrough';

var MarkdownMobileComponent = function (_a) {
    var children = _a.children, restProps = __rest(_a, ["children"]);
    return (React.createElement(Markdown, __assign({}, restProps, { platform: 'mobile' }), children));
};

export { MarkdownMobileComponent };
